import { Skeleton } from '@/components/ui/skeleton';
import { useChangeCommitmentExpectBy, useCheckInCommitment, useCloseCommitment, useOpenCommitments } from '@/hooks/queries';
import { getCampaignTodayString } from '@/lib/calendarUtils';
import { FundraisingPage } from './FundraisingPage';
import { OpenCommitmentsList } from './OpenCommitmentsList';

/**
 * The Open commitments tab: who committed how much on a call, so the Fundraiser can chase it — logging
 * check-ins and moving the expected date as they go. A commitment stays open until it's closed — by the
 * Fundraiser (received elsewhere, withdrawn or lapsed), or by the system (superseded, logged in error).
 */
export function OpenCommitments() {
  const { data, isLoading, isError } = useOpenCommitments();
  const { mutate: close, isPending, variables, error } = useCloseCommitment();
  const { mutateAsync: checkIn } = useCheckInCommitment();
  const { mutateAsync: changeExpectBy } = useChangeCommitmentExpectBy();

  return (
    <FundraisingPage tab="commitments">
      <div className="space-y-6">
        {isLoading && (
          <div className="space-y-3">
            {[0, 1, 2].map((i) => (
              <Skeleton key={i} className="h-14 w-full" />
            ))}
          </div>
        )}
        {isError && !isLoading && (
          <p className="text-sm text-muted-foreground">We couldn&apos;t load the open commitments right now.</p>
        )}
        {data && (
          <OpenCommitmentsList
            commitments={data}
            onClose={(id, request) => close({ id, request })}
            onCheckIn={(id, note) => checkIn({ id, note })}
            onChangeExpectBy={(id, expectBy) => changeExpectBy({ id, expectBy })}
            closingId={isPending ? (variables?.id ?? null) : null}
            error={error?.message ?? null}
            today={getCampaignTodayString()}
          />
        )}
      </div>
    </FundraisingPage>
  );
}
